export const technologyRoutes = [
  {
    title: 'SDK',
    path: '/sdk',
  },
  {
    title: 'Platform',
    path: '/platform',
  },
]

export const routes = [
  {
    title: 'Pro Audio',
    path: '/soundcore',
  },
  {
    title: 'Automotive',
    path: '/soundscape',
  },
  {
    title: 'Resources',
    path: '/resources',
  },
  {
    title: 'About',
    path: '/about',
  },
]
